import React, { useCallback, useEffect, useState } from "react";
import { AlertLineURLApiService } from "../../services/alert-line/alert-line-url-api.service";
import { useTranslation } from "react-i18next";

const AlertLineURLLogo = ({ alertLineURLId }: { alertLineURLId: string }) => {
  const tRPFields = "components.add_edit_alert_line_url.fields";
  const { t } = useTranslation();
  const [logo, setLogo] = useState<string>("");

  const loadLogo = useCallback(async () => {
    try {
      const response = await new AlertLineURLApiService().getAlertLineURLLogo(alertLineURLId);
      if (response.size > 0) {
        const logoUrl = URL.createObjectURL(response);
        setLogo(logoUrl);
      }
    } catch (error) {}
  }, [alertLineURLId]);

  useEffect(() => {
    loadLogo();
  }, [alertLineURLId]);

  return !!logo ? (
    <img
      width="50"
      src={logo}
      alt={`${t(`${tRPFields}.logo`)}`}
    />
  ) : (
    <></>
  );
};
export default AlertLineURLLogo;
